import { Skeleton } from "@/components/ui/skeleton";

export const AccountingSkeleton = () => (
  <div className="flex flex-col gap-2" aria-busy>
    <Skeleton className="h-8 w-64" />
    <Skeleton className="h-24 w-full" />
    <Skeleton className="h-10 w-full" />
  </div>
);
